import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    saveItem(key: string, value: string) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error('Error saving to local storage', error);
        }
    }

    getItem(key: string): string | null {
        try {
            const stringValue = localStorage.getItem(key);

            return stringValue;
        } catch (error) {
            console.error('Error getting data from local storage', error);

            return null;
        }
    }

    removeItem(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing data from local storage', error);
        }
    }

    clear(): void {
        localStorage.clear();
    }
}